import Loader from 'components/Common/Loader'

const InputLoading = () => {
  return <Loader color='var(--color-velvet)' size='16px' width='8' />
}

export default InputLoading
